import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const buyers = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  city: 'Córdoba'
}, {
  name: 'Luciana M.',
  city: 'Rosario'
}, {
  name: 'Valentina R.',
  city: 'Mendoza'
}, {
  name: 'Florencia G.',
  city: 'La Plata'
}, {
  name: 'Camila P.',
  city: 'Tucumán'
}, {
  name: 'Julieta D.',
  city: 'Mar del Plata'
}, {
  name: 'Agustina B.',
  city: 'Salta'
}, {
  name: 'Romina F.',
  city: 'Santa Fe'
}, {
  name: 'Paula T.',
  city: 'Neuquén'
}, {
  name: 'Daniela V.',
  city: 'Bahía Blanca'
}, {
  name: 'Sofía K.',
  city: 'San Isidro'
}, {
  name: 'Martina C.',
  city: 'Quilmes'
}, {
  name: 'Andrea H.',
  city: 'Paraná'
}, {
  name: 'Laura N.',
  city: 'Resistencia'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 15) + 1;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(() => ({
    ...buyers[Math.floor(Math.random() * buyers.length)],
    minutes: getRandomMinutes()
  }));
  const showNotification = useCallback(() => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer({
      ...randomBuyer,
      minutes: getRandomMinutes()
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 4500);
  }, []);
  useEffect(() => {
    // First notification after 15 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 15000);
    // Then every 25-60 seconds
    const interval = setInterval(() => {
      showNotification();
    }, 25000 + Math.random() * 35000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[320px]" data-id="element-420">
      <AnimatePresence data-id="element-421">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 20,
        x: -20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        x: -10,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="bg-white border border-surface rounded-2xl shadow-lg p-4 flex items-center gap-3" data-id="element-422">
            {/* Icon */}
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-423">
              <ShoppingBagIcon className="w-5 h-5 text-primary" data-id="element-424" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-425">
              <p className="text-sm font-semibold text-charcoal leading-snug" data-id="element-426">
                {currentBuyer.name}{' '}
                <img src="https://flagcdn.com/w20/ar.png" alt="AR" className="inline-block w-4 h-auto align-middle ml-0.5" data-id="element-427" />
              </p>
              <p className="text-xs text-charcoal/60 leading-snug mt-0.5" data-id="element-428">
                Compró el recetario desde{' '}
                <span className="font-medium text-charcoal/80" data-id="element-429">
                  {currentBuyer.city}
                </span>
              </p>
              <p className="text-[11px] text-charcoal/40 mt-1" data-id="element-430">
                hace {currentBuyer.minutes}{' '}
                {currentBuyer.minutes === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}